import { DeprecatedIcon } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";

const HeaderHelpButton = _ref => {
  let {
    testId,
    url
  } = _ref;
  const translate = useTranslate('header'); // TODO: this is considered a UI debt, as all clickable icons should be placed into buttons

  return /*#__PURE__*/_jsx("a", {
    "data-testid": testId,
    className: "u-flexbox u-align-items-center",
    href: url,
    children: /*#__PURE__*/_jsx(DeprecatedIcon, {
      name: "question-circle",
      aria: {
        'aria-label': translate('a11y.help')
      },
      color: DeprecatedIcon.Color.GreyscaleLevel4
    })
  });
};

export default HeaderHelpButton;